module.exports = __webpack_public_path__ + "img/image (96).569c3f91.jpg";